import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-2 pb-4 mx-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-3 text-size-14 text-mild" }, "\n        より多くの資格証をご登録いただくと、応募可能な仕事が増えます\n      ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_StepBar = _resolveComponent("StepBar")!
  const _component_QualificationItem = _resolveComponent("QualificationItem")!
  const _component_AddQualificationItem = _resolveComponent("AddQualificationItem")!
  const _component_BottomFormActionButtons = _resolveComponent("BottomFormActionButtons")!
  const _component_BlockBack = _resolveComponent("BlockBack")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      default: _withCtx(() => [
        _createTextVNode("\n      保有資格\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_StepBar, {
        maxValue: 4,
        currentValue: 2,
        class: "mb-3"
      }),
      _createTextVNode(),
      _hoisted_2,
      _createTextVNode(),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.qualifications, (qualification, index) => {
        return (_openBlock(), _createBlock(_component_QualificationItem, {
          key: index,
          status: qualification.status,
          class: "mt-2"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.getQualificationName(qualification.qualification)), 1)
          ], undefined, true),
          _: 2
        }, 1032, ["status"]))
      }), 128)),
      _createTextVNode(),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputtedQualifications, (qualification, index) => {
        return (_openBlock(), _createBlock(_component_QualificationItem, {
          key: index,
          status: "unverified",
          class: "mt-2"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.getQualificationName(qualification.qualification)), 1)
          ], undefined, true),
          _: 2
        }, 1024))
      }), 128)),
      _createTextVNode(),
      _createVNode(_component_AddQualificationItem, {
        to: { name: 'RegisterAddQualification' },
        class: "mt-2"
      }),
      _createTextVNode(),
      _createVNode(_component_BottomFormActionButtons, {
        submitButtonText: "次へ",
        skipButtonText: "スキップする",
        onSubmit: _ctx.onClickSubmit,
        onSkip: _ctx.onClickSkip
      }, null, 8, ["onSubmit", "onSkip"])
    ]),
    _createTextVNode(),
    _createVNode(_component_BlockBack)
  ]))
}